/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StoreRouteImport } from './routes/store'
import { Route as CompanyRouteImport } from './routes/company'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StoreIndexRouteImport } from './routes/store/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as StoreTransactionsRouteImport } from './routes/store/transactions'
import { Route as StoreQrcodeRouteImport } from './routes/store/qrcode'
import { Route as StoreDashboardRouteImport } from './routes/store/dashboard'
import { Route as LoginStoreRouteImport } from './routes/login/store'
import { Route as LoginCompanyRouteImport } from './routes/login/company'
import { Route as LoginAdminRouteImport } from './routes/login/admin'
import { Route as CompanyTransactionsRouteImport } from './routes/company/transactions'
import { Route as CompanyRedemptionsRouteImport } from './routes/company/redemptions'
import { Route as CompanyDashboardRouteImport } from './routes/company/dashboard'
import { Route as CompanyContactRouteImport } from './routes/company/contact'
import { Route as CompanyStoresIndexRouteImport } from './routes/company/stores/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminStoresIndexRouteImport } from './routes/admin/stores/index'
import { Route as AdminSettlementsIndexRouteImport } from './routes/admin/settlements/index'
import { Route as AdminPointsIndexRouteImport } from './routes/admin/points/index'
import { Route as AdminNotificationsIndexRouteImport } from './routes/admin/notifications/index'
import { Route as AdminFundSourcesIndexRouteImport } from './routes/admin/fundSources/index'
import { Route as AdminDistributionCodesIndexRouteImport } from './routes/admin/distribution-codes/index'
import { Route as AdminCompaniesIndexRouteImport } from './routes/admin/companies/index'
import { Route as AdminNotificationsNewRouteImport } from './routes/admin/notifications/new'
import { Route as AdminNotificationsIdRouteImport } from './routes/admin/notifications/$id'
import { Route as AdminFundSourcesNewFundSourceRouteImport } from './routes/admin/fundSources/newFundSource'
import { Route as AdminCompaniesNewCompanyRouteImport } from './routes/admin/companies/newCompany'
import { Route as CompanyStoresStoreSlugIndexRouteImport } from './routes/company/stores/$storeSlug/index'
import { Route as AdminUsersSubscriptionOrUserIdIndexRouteImport } from './routes/admin/users/$subscriptionOrUserId/index'
import { Route as AdminPointsBulkGrantPointsIndexRouteImport } from './routes/admin/points/bulkGrantPoints/index'
import { Route as AdminPointsBulkCreateStandaloneDistributionCodesIndexRouteImport } from './routes/admin/points/bulkCreateStandaloneDistributionCodes/index'
import { Route as AdminPointsFundSourceIdIndexRouteImport } from './routes/admin/points/$fundSourceId/index'
import { Route as AdminHokkaidoPostalReturnsIndexRouteImport } from './routes/admin/hokkaido/postal-returns/index'
import { Route as AdminHokkaidoPaperVouchersIndexRouteImport } from './routes/admin/hokkaido/paper-vouchers/index'
import { Route as AdminHokkaidoMynaApplicationsIndexRouteImport } from './routes/admin/hokkaido/myna-applications/index'
import { Route as AdminHokkaidoExportsIndexRouteImport } from './routes/admin/hokkaido/exports/index'
import { Route as AdminHokkaidoCsvsIndexRouteImport } from './routes/admin/hokkaido/csvs/index'
import { Route as AdminHokkaidoCodeStatusesIndexRouteImport } from './routes/admin/hokkaido/code-statuses/index'
import { Route as AdminCompaniesBulkCreateStoreAccountsIndexRouteImport } from './routes/admin/companies/bulkCreateStoreAccounts/index'
import { Route as AdminCompaniesBulkCreateStaffAccountsIndexRouteImport } from './routes/admin/companies/bulkCreateStaffAccounts/index'
import { Route as AdminCompaniesBulkCreateQrcodesIndexRouteImport } from './routes/admin/companies/bulkCreateQrcodes/index'
import { Route as AdminCompaniesBulkCreateCompaniesIndexRouteImport } from './routes/admin/companies/bulkCreateCompanies/index'
import { Route as AdminCompaniesCompanyIdIndexRouteImport } from './routes/admin/companies/$companyId/index'
import { Route as CompanyStoresStoreSlugQrcodeRouteImport } from './routes/company/stores/$storeSlug/qrcode'
import { Route as AdminUsersSubscriptionOrUserIdIssueBalanceRouteImport } from './routes/admin/users/$subscriptionOrUserId/issueBalance'
import { Route as AdminUsersSubscriptionOrUserIdCreateNotificationRouteImport } from './routes/admin/users/$subscriptionOrUserId/createNotification'
import { Route as AdminPointsFundSourceIdNewCampaignRouteImport } from './routes/admin/points/$fundSourceId/newCampaign'
import { Route as AdminFundSourcesFundSourceIdEditRouteImport } from './routes/admin/fundSources/$fundSourceId/edit'
import { Route as AdminCompaniesCompanyIdNewStoresRouteImport } from './routes/admin/companies/$companyId/newStores'
import { Route as AdminCompaniesCompanyIdStoreIdIndexRouteImport } from './routes/admin/companies/$companyId/$storeId/index'
import { Route as AdminUsersSubscriptionOrUserIdNotificationsIdRouteImport } from './routes/admin/users/$subscriptionOrUserId/notifications/$id'
import { Route as AdminCompaniesCompanyIdStoreIdEditRouteImport } from './routes/admin/companies/$companyId/$storeId/edit'

const StoreRoute = StoreRouteImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyRoute = CompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreIndexRoute = StoreIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StoreRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const StoreTransactionsRoute = StoreTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => StoreRoute,
} as any)
const StoreQrcodeRoute = StoreQrcodeRouteImport.update({
  id: '/qrcode',
  path: '/qrcode',
  getParentRoute: () => StoreRoute,
} as any)
const StoreDashboardRoute = StoreDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => StoreRoute,
} as any)
const LoginStoreRoute = LoginStoreRouteImport.update({
  id: '/login/store',
  path: '/login/store',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginCompanyRoute = LoginCompanyRouteImport.update({
  id: '/login/company',
  path: '/login/company',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginAdminRoute = LoginAdminRouteImport.update({
  id: '/login/admin',
  path: '/login/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyTransactionsRoute = CompanyTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyRedemptionsRoute = CompanyRedemptionsRouteImport.update({
  id: '/redemptions',
  path: '/redemptions',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyDashboardRoute = CompanyDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyContactRoute = CompanyContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyStoresIndexRoute = CompanyStoresIndexRouteImport.update({
  id: '/stores/',
  path: '/stores/',
  getParentRoute: () => CompanyRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStoresIndexRoute = AdminStoresIndexRouteImport.update({
  id: '/stores/',
  path: '/stores/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettlementsIndexRoute = AdminSettlementsIndexRouteImport.update({
  id: '/settlements/',
  path: '/settlements/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPointsIndexRoute = AdminPointsIndexRouteImport.update({
  id: '/points/',
  path: '/points/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNotificationsIndexRoute = AdminNotificationsIndexRouteImport.update({
  id: '/notifications/',
  path: '/notifications/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFundSourcesIndexRoute = AdminFundSourcesIndexRouteImport.update({
  id: '/fundSources/',
  path: '/fundSources/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDistributionCodesIndexRoute =
  AdminDistributionCodesIndexRouteImport.update({
    id: '/distribution-codes/',
    path: '/distribution-codes/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCompaniesIndexRoute = AdminCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNotificationsNewRoute = AdminNotificationsNewRouteImport.update({
  id: '/notifications/new',
  path: '/notifications/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminNotificationsIdRoute = AdminNotificationsIdRouteImport.update({
  id: '/notifications/$id',
  path: '/notifications/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFundSourcesNewFundSourceRoute =
  AdminFundSourcesNewFundSourceRouteImport.update({
    id: '/fundSources/newFundSource',
    path: '/fundSources/newFundSource',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCompaniesNewCompanyRoute =
  AdminCompaniesNewCompanyRouteImport.update({
    id: '/companies/newCompany',
    path: '/companies/newCompany',
    getParentRoute: () => AdminRoute,
  } as any)
const CompanyStoresStoreSlugIndexRoute =
  CompanyStoresStoreSlugIndexRouteImport.update({
    id: '/stores/$storeSlug/',
    path: '/stores/$storeSlug/',
    getParentRoute: () => CompanyRoute,
  } as any)
const AdminUsersSubscriptionOrUserIdIndexRoute =
  AdminUsersSubscriptionOrUserIdIndexRouteImport.update({
    id: '/users/$subscriptionOrUserId/',
    path: '/users/$subscriptionOrUserId/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminPointsBulkGrantPointsIndexRoute =
  AdminPointsBulkGrantPointsIndexRouteImport.update({
    id: '/points/bulkGrantPoints/',
    path: '/points/bulkGrantPoints/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminPointsBulkCreateStandaloneDistributionCodesIndexRoute =
  AdminPointsBulkCreateStandaloneDistributionCodesIndexRouteImport.update({
    id: '/points/bulkCreateStandaloneDistributionCodes/',
    path: '/points/bulkCreateStandaloneDistributionCodes/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminPointsFundSourceIdIndexRoute =
  AdminPointsFundSourceIdIndexRouteImport.update({
    id: '/points/$fundSourceId/',
    path: '/points/$fundSourceId/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminHokkaidoPostalReturnsIndexRoute =
  AdminHokkaidoPostalReturnsIndexRouteImport.update({
    id: '/hokkaido/postal-returns/',
    path: '/hokkaido/postal-returns/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminHokkaidoPaperVouchersIndexRoute =
  AdminHokkaidoPaperVouchersIndexRouteImport.update({
    id: '/hokkaido/paper-vouchers/',
    path: '/hokkaido/paper-vouchers/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminHokkaidoMynaApplicationsIndexRoute =
  AdminHokkaidoMynaApplicationsIndexRouteImport.update({
    id: '/hokkaido/myna-applications/',
    path: '/hokkaido/myna-applications/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminHokkaidoExportsIndexRoute =
  AdminHokkaidoExportsIndexRouteImport.update({
    id: '/hokkaido/exports/',
    path: '/hokkaido/exports/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminHokkaidoCsvsIndexRoute = AdminHokkaidoCsvsIndexRouteImport.update({
  id: '/hokkaido/csvs/',
  path: '/hokkaido/csvs/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminHokkaidoCodeStatusesIndexRoute =
  AdminHokkaidoCodeStatusesIndexRouteImport.update({
    id: '/hokkaido/code-statuses/',
    path: '/hokkaido/code-statuses/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCompaniesBulkCreateStoreAccountsIndexRoute =
  AdminCompaniesBulkCreateStoreAccountsIndexRouteImport.update({
    id: '/companies/bulkCreateStoreAccounts/',
    path: '/companies/bulkCreateStoreAccounts/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCompaniesBulkCreateStaffAccountsIndexRoute =
  AdminCompaniesBulkCreateStaffAccountsIndexRouteImport.update({
    id: '/companies/bulkCreateStaffAccounts/',
    path: '/companies/bulkCreateStaffAccounts/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCompaniesBulkCreateQrcodesIndexRoute =
  AdminCompaniesBulkCreateQrcodesIndexRouteImport.update({
    id: '/companies/bulkCreateQrcodes/',
    path: '/companies/bulkCreateQrcodes/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCompaniesBulkCreateCompaniesIndexRoute =
  AdminCompaniesBulkCreateCompaniesIndexRouteImport.update({
    id: '/companies/bulkCreateCompanies/',
    path: '/companies/bulkCreateCompanies/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCompaniesCompanyIdIndexRoute =
  AdminCompaniesCompanyIdIndexRouteImport.update({
    id: '/companies/$companyId/',
    path: '/companies/$companyId/',
    getParentRoute: () => AdminRoute,
  } as any)
const CompanyStoresStoreSlugQrcodeRoute =
  CompanyStoresStoreSlugQrcodeRouteImport.update({
    id: '/stores/$storeSlug/qrcode',
    path: '/stores/$storeSlug/qrcode',
    getParentRoute: () => CompanyRoute,
  } as any)
const AdminUsersSubscriptionOrUserIdIssueBalanceRoute =
  AdminUsersSubscriptionOrUserIdIssueBalanceRouteImport.update({
    id: '/users/$subscriptionOrUserId/issueBalance',
    path: '/users/$subscriptionOrUserId/issueBalance',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminUsersSubscriptionOrUserIdCreateNotificationRoute =
  AdminUsersSubscriptionOrUserIdCreateNotificationRouteImport.update({
    id: '/users/$subscriptionOrUserId/createNotification',
    path: '/users/$subscriptionOrUserId/createNotification',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminPointsFundSourceIdNewCampaignRoute =
  AdminPointsFundSourceIdNewCampaignRouteImport.update({
    id: '/points/$fundSourceId/newCampaign',
    path: '/points/$fundSourceId/newCampaign',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminFundSourcesFundSourceIdEditRoute =
  AdminFundSourcesFundSourceIdEditRouteImport.update({
    id: '/fundSources/$fundSourceId/edit',
    path: '/fundSources/$fundSourceId/edit',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCompaniesCompanyIdNewStoresRoute =
  AdminCompaniesCompanyIdNewStoresRouteImport.update({
    id: '/companies/$companyId/newStores',
    path: '/companies/$companyId/newStores',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCompaniesCompanyIdStoreIdIndexRoute =
  AdminCompaniesCompanyIdStoreIdIndexRouteImport.update({
    id: '/companies/$companyId/$storeId/',
    path: '/companies/$companyId/$storeId/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminUsersSubscriptionOrUserIdNotificationsIdRoute =
  AdminUsersSubscriptionOrUserIdNotificationsIdRouteImport.update({
    id: '/users/$subscriptionOrUserId/notifications/$id',
    path: '/users/$subscriptionOrUserId/notifications/$id',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCompaniesCompanyIdStoreIdEditRoute =
  AdminCompaniesCompanyIdStoreIdEditRouteImport.update({
    id: '/companies/$companyId/$storeId/edit',
    path: '/companies/$companyId/$storeId/edit',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/company': typeof CompanyRouteWithChildren
  '/store': typeof StoreRouteWithChildren
  '/company/contact': typeof CompanyContactRoute
  '/company/dashboard': typeof CompanyDashboardRoute
  '/company/redemptions': typeof CompanyRedemptionsRoute
  '/company/transactions': typeof CompanyTransactionsRoute
  '/login/admin': typeof LoginAdminRoute
  '/login/company': typeof LoginCompanyRoute
  '/login/store': typeof LoginStoreRoute
  '/store/dashboard': typeof StoreDashboardRoute
  '/store/qrcode': typeof StoreQrcodeRoute
  '/store/transactions': typeof StoreTransactionsRoute
  '/admin/': typeof AdminIndexRoute
  '/store/': typeof StoreIndexRoute
  '/admin/companies/newCompany': typeof AdminCompaniesNewCompanyRoute
  '/admin/fundSources/newFundSource': typeof AdminFundSourcesNewFundSourceRoute
  '/admin/notifications/$id': typeof AdminNotificationsIdRoute
  '/admin/notifications/new': typeof AdminNotificationsNewRoute
  '/admin/companies': typeof AdminCompaniesIndexRoute
  '/admin/distribution-codes': typeof AdminDistributionCodesIndexRoute
  '/admin/fundSources': typeof AdminFundSourcesIndexRoute
  '/admin/notifications': typeof AdminNotificationsIndexRoute
  '/admin/points': typeof AdminPointsIndexRoute
  '/admin/settlements': typeof AdminSettlementsIndexRoute
  '/admin/stores': typeof AdminStoresIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/company/stores': typeof CompanyStoresIndexRoute
  '/admin/companies/$companyId/newStores': typeof AdminCompaniesCompanyIdNewStoresRoute
  '/admin/fundSources/$fundSourceId/edit': typeof AdminFundSourcesFundSourceIdEditRoute
  '/admin/points/$fundSourceId/newCampaign': typeof AdminPointsFundSourceIdNewCampaignRoute
  '/admin/users/$subscriptionOrUserId/createNotification': typeof AdminUsersSubscriptionOrUserIdCreateNotificationRoute
  '/admin/users/$subscriptionOrUserId/issueBalance': typeof AdminUsersSubscriptionOrUserIdIssueBalanceRoute
  '/company/stores/$storeSlug/qrcode': typeof CompanyStoresStoreSlugQrcodeRoute
  '/admin/companies/$companyId': typeof AdminCompaniesCompanyIdIndexRoute
  '/admin/companies/bulkCreateCompanies': typeof AdminCompaniesBulkCreateCompaniesIndexRoute
  '/admin/companies/bulkCreateQrcodes': typeof AdminCompaniesBulkCreateQrcodesIndexRoute
  '/admin/companies/bulkCreateStaffAccounts': typeof AdminCompaniesBulkCreateStaffAccountsIndexRoute
  '/admin/companies/bulkCreateStoreAccounts': typeof AdminCompaniesBulkCreateStoreAccountsIndexRoute
  '/admin/hokkaido/code-statuses': typeof AdminHokkaidoCodeStatusesIndexRoute
  '/admin/hokkaido/csvs': typeof AdminHokkaidoCsvsIndexRoute
  '/admin/hokkaido/exports': typeof AdminHokkaidoExportsIndexRoute
  '/admin/hokkaido/myna-applications': typeof AdminHokkaidoMynaApplicationsIndexRoute
  '/admin/hokkaido/paper-vouchers': typeof AdminHokkaidoPaperVouchersIndexRoute
  '/admin/hokkaido/postal-returns': typeof AdminHokkaidoPostalReturnsIndexRoute
  '/admin/points/$fundSourceId': typeof AdminPointsFundSourceIdIndexRoute
  '/admin/points/bulkCreateStandaloneDistributionCodes': typeof AdminPointsBulkCreateStandaloneDistributionCodesIndexRoute
  '/admin/points/bulkGrantPoints': typeof AdminPointsBulkGrantPointsIndexRoute
  '/admin/users/$subscriptionOrUserId': typeof AdminUsersSubscriptionOrUserIdIndexRoute
  '/company/stores/$storeSlug': typeof CompanyStoresStoreSlugIndexRoute
  '/admin/companies/$companyId/$storeId/edit': typeof AdminCompaniesCompanyIdStoreIdEditRoute
  '/admin/users/$subscriptionOrUserId/notifications/$id': typeof AdminUsersSubscriptionOrUserIdNotificationsIdRoute
  '/admin/companies/$companyId/$storeId': typeof AdminCompaniesCompanyIdStoreIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/company': typeof CompanyRouteWithChildren
  '/company/contact': typeof CompanyContactRoute
  '/company/dashboard': typeof CompanyDashboardRoute
  '/company/redemptions': typeof CompanyRedemptionsRoute
  '/company/transactions': typeof CompanyTransactionsRoute
  '/login/admin': typeof LoginAdminRoute
  '/login/company': typeof LoginCompanyRoute
  '/login/store': typeof LoginStoreRoute
  '/store/dashboard': typeof StoreDashboardRoute
  '/store/qrcode': typeof StoreQrcodeRoute
  '/store/transactions': typeof StoreTransactionsRoute
  '/admin': typeof AdminIndexRoute
  '/store': typeof StoreIndexRoute
  '/admin/companies/newCompany': typeof AdminCompaniesNewCompanyRoute
  '/admin/fundSources/newFundSource': typeof AdminFundSourcesNewFundSourceRoute
  '/admin/notifications/$id': typeof AdminNotificationsIdRoute
  '/admin/notifications/new': typeof AdminNotificationsNewRoute
  '/admin/companies': typeof AdminCompaniesIndexRoute
  '/admin/distribution-codes': typeof AdminDistributionCodesIndexRoute
  '/admin/fundSources': typeof AdminFundSourcesIndexRoute
  '/admin/notifications': typeof AdminNotificationsIndexRoute
  '/admin/points': typeof AdminPointsIndexRoute
  '/admin/settlements': typeof AdminSettlementsIndexRoute
  '/admin/stores': typeof AdminStoresIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/company/stores': typeof CompanyStoresIndexRoute
  '/admin/companies/$companyId/newStores': typeof AdminCompaniesCompanyIdNewStoresRoute
  '/admin/fundSources/$fundSourceId/edit': typeof AdminFundSourcesFundSourceIdEditRoute
  '/admin/points/$fundSourceId/newCampaign': typeof AdminPointsFundSourceIdNewCampaignRoute
  '/admin/users/$subscriptionOrUserId/createNotification': typeof AdminUsersSubscriptionOrUserIdCreateNotificationRoute
  '/admin/users/$subscriptionOrUserId/issueBalance': typeof AdminUsersSubscriptionOrUserIdIssueBalanceRoute
  '/company/stores/$storeSlug/qrcode': typeof CompanyStoresStoreSlugQrcodeRoute
  '/admin/companies/$companyId': typeof AdminCompaniesCompanyIdIndexRoute
  '/admin/companies/bulkCreateCompanies': typeof AdminCompaniesBulkCreateCompaniesIndexRoute
  '/admin/companies/bulkCreateQrcodes': typeof AdminCompaniesBulkCreateQrcodesIndexRoute
  '/admin/companies/bulkCreateStaffAccounts': typeof AdminCompaniesBulkCreateStaffAccountsIndexRoute
  '/admin/companies/bulkCreateStoreAccounts': typeof AdminCompaniesBulkCreateStoreAccountsIndexRoute
  '/admin/hokkaido/code-statuses': typeof AdminHokkaidoCodeStatusesIndexRoute
  '/admin/hokkaido/csvs': typeof AdminHokkaidoCsvsIndexRoute
  '/admin/hokkaido/exports': typeof AdminHokkaidoExportsIndexRoute
  '/admin/hokkaido/myna-applications': typeof AdminHokkaidoMynaApplicationsIndexRoute
  '/admin/hokkaido/paper-vouchers': typeof AdminHokkaidoPaperVouchersIndexRoute
  '/admin/hokkaido/postal-returns': typeof AdminHokkaidoPostalReturnsIndexRoute
  '/admin/points/$fundSourceId': typeof AdminPointsFundSourceIdIndexRoute
  '/admin/points/bulkCreateStandaloneDistributionCodes': typeof AdminPointsBulkCreateStandaloneDistributionCodesIndexRoute
  '/admin/points/bulkGrantPoints': typeof AdminPointsBulkGrantPointsIndexRoute
  '/admin/users/$subscriptionOrUserId': typeof AdminUsersSubscriptionOrUserIdIndexRoute
  '/company/stores/$storeSlug': typeof CompanyStoresStoreSlugIndexRoute
  '/admin/companies/$companyId/$storeId/edit': typeof AdminCompaniesCompanyIdStoreIdEditRoute
  '/admin/users/$subscriptionOrUserId/notifications/$id': typeof AdminUsersSubscriptionOrUserIdNotificationsIdRoute
  '/admin/companies/$companyId/$storeId': typeof AdminCompaniesCompanyIdStoreIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/company': typeof CompanyRouteWithChildren
  '/store': typeof StoreRouteWithChildren
  '/company/contact': typeof CompanyContactRoute
  '/company/dashboard': typeof CompanyDashboardRoute
  '/company/redemptions': typeof CompanyRedemptionsRoute
  '/company/transactions': typeof CompanyTransactionsRoute
  '/login/admin': typeof LoginAdminRoute
  '/login/company': typeof LoginCompanyRoute
  '/login/store': typeof LoginStoreRoute
  '/store/dashboard': typeof StoreDashboardRoute
  '/store/qrcode': typeof StoreQrcodeRoute
  '/store/transactions': typeof StoreTransactionsRoute
  '/admin/': typeof AdminIndexRoute
  '/store/': typeof StoreIndexRoute
  '/admin/companies/newCompany': typeof AdminCompaniesNewCompanyRoute
  '/admin/fundSources/newFundSource': typeof AdminFundSourcesNewFundSourceRoute
  '/admin/notifications/$id': typeof AdminNotificationsIdRoute
  '/admin/notifications/new': typeof AdminNotificationsNewRoute
  '/admin/companies/': typeof AdminCompaniesIndexRoute
  '/admin/distribution-codes/': typeof AdminDistributionCodesIndexRoute
  '/admin/fundSources/': typeof AdminFundSourcesIndexRoute
  '/admin/notifications/': typeof AdminNotificationsIndexRoute
  '/admin/points/': typeof AdminPointsIndexRoute
  '/admin/settlements/': typeof AdminSettlementsIndexRoute
  '/admin/stores/': typeof AdminStoresIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/company/stores/': typeof CompanyStoresIndexRoute
  '/admin/companies/$companyId/newStores': typeof AdminCompaniesCompanyIdNewStoresRoute
  '/admin/fundSources/$fundSourceId/edit': typeof AdminFundSourcesFundSourceIdEditRoute
  '/admin/points/$fundSourceId/newCampaign': typeof AdminPointsFundSourceIdNewCampaignRoute
  '/admin/users/$subscriptionOrUserId/createNotification': typeof AdminUsersSubscriptionOrUserIdCreateNotificationRoute
  '/admin/users/$subscriptionOrUserId/issueBalance': typeof AdminUsersSubscriptionOrUserIdIssueBalanceRoute
  '/company/stores/$storeSlug/qrcode': typeof CompanyStoresStoreSlugQrcodeRoute
  '/admin/companies/$companyId/': typeof AdminCompaniesCompanyIdIndexRoute
  '/admin/companies/bulkCreateCompanies/': typeof AdminCompaniesBulkCreateCompaniesIndexRoute
  '/admin/companies/bulkCreateQrcodes/': typeof AdminCompaniesBulkCreateQrcodesIndexRoute
  '/admin/companies/bulkCreateStaffAccounts/': typeof AdminCompaniesBulkCreateStaffAccountsIndexRoute
  '/admin/companies/bulkCreateStoreAccounts/': typeof AdminCompaniesBulkCreateStoreAccountsIndexRoute
  '/admin/hokkaido/code-statuses/': typeof AdminHokkaidoCodeStatusesIndexRoute
  '/admin/hokkaido/csvs/': typeof AdminHokkaidoCsvsIndexRoute
  '/admin/hokkaido/exports/': typeof AdminHokkaidoExportsIndexRoute
  '/admin/hokkaido/myna-applications/': typeof AdminHokkaidoMynaApplicationsIndexRoute
  '/admin/hokkaido/paper-vouchers/': typeof AdminHokkaidoPaperVouchersIndexRoute
  '/admin/hokkaido/postal-returns/': typeof AdminHokkaidoPostalReturnsIndexRoute
  '/admin/points/$fundSourceId/': typeof AdminPointsFundSourceIdIndexRoute
  '/admin/points/bulkCreateStandaloneDistributionCodes/': typeof AdminPointsBulkCreateStandaloneDistributionCodesIndexRoute
  '/admin/points/bulkGrantPoints/': typeof AdminPointsBulkGrantPointsIndexRoute
  '/admin/users/$subscriptionOrUserId/': typeof AdminUsersSubscriptionOrUserIdIndexRoute
  '/company/stores/$storeSlug/': typeof CompanyStoresStoreSlugIndexRoute
  '/admin/companies/$companyId/$storeId/edit': typeof AdminCompaniesCompanyIdStoreIdEditRoute
  '/admin/users/$subscriptionOrUserId/notifications/$id': typeof AdminUsersSubscriptionOrUserIdNotificationsIdRoute
  '/admin/companies/$companyId/$storeId/': typeof AdminCompaniesCompanyIdStoreIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/company'
    | '/store'
    | '/company/contact'
    | '/company/dashboard'
    | '/company/redemptions'
    | '/company/transactions'
    | '/login/admin'
    | '/login/company'
    | '/login/store'
    | '/store/dashboard'
    | '/store/qrcode'
    | '/store/transactions'
    | '/admin/'
    | '/store/'
    | '/admin/companies/newCompany'
    | '/admin/fundSources/newFundSource'
    | '/admin/notifications/$id'
    | '/admin/notifications/new'
    | '/admin/companies'
    | '/admin/distribution-codes'
    | '/admin/fundSources'
    | '/admin/notifications'
    | '/admin/points'
    | '/admin/settlements'
    | '/admin/stores'
    | '/admin/users'
    | '/company/stores'
    | '/admin/companies/$companyId/newStores'
    | '/admin/fundSources/$fundSourceId/edit'
    | '/admin/points/$fundSourceId/newCampaign'
    | '/admin/users/$subscriptionOrUserId/createNotification'
    | '/admin/users/$subscriptionOrUserId/issueBalance'
    | '/company/stores/$storeSlug/qrcode'
    | '/admin/companies/$companyId'
    | '/admin/companies/bulkCreateCompanies'
    | '/admin/companies/bulkCreateQrcodes'
    | '/admin/companies/bulkCreateStaffAccounts'
    | '/admin/companies/bulkCreateStoreAccounts'
    | '/admin/hokkaido/code-statuses'
    | '/admin/hokkaido/csvs'
    | '/admin/hokkaido/exports'
    | '/admin/hokkaido/myna-applications'
    | '/admin/hokkaido/paper-vouchers'
    | '/admin/hokkaido/postal-returns'
    | '/admin/points/$fundSourceId'
    | '/admin/points/bulkCreateStandaloneDistributionCodes'
    | '/admin/points/bulkGrantPoints'
    | '/admin/users/$subscriptionOrUserId'
    | '/company/stores/$storeSlug'
    | '/admin/companies/$companyId/$storeId/edit'
    | '/admin/users/$subscriptionOrUserId/notifications/$id'
    | '/admin/companies/$companyId/$storeId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/company'
    | '/company/contact'
    | '/company/dashboard'
    | '/company/redemptions'
    | '/company/transactions'
    | '/login/admin'
    | '/login/company'
    | '/login/store'
    | '/store/dashboard'
    | '/store/qrcode'
    | '/store/transactions'
    | '/admin'
    | '/store'
    | '/admin/companies/newCompany'
    | '/admin/fundSources/newFundSource'
    | '/admin/notifications/$id'
    | '/admin/notifications/new'
    | '/admin/companies'
    | '/admin/distribution-codes'
    | '/admin/fundSources'
    | '/admin/notifications'
    | '/admin/points'
    | '/admin/settlements'
    | '/admin/stores'
    | '/admin/users'
    | '/company/stores'
    | '/admin/companies/$companyId/newStores'
    | '/admin/fundSources/$fundSourceId/edit'
    | '/admin/points/$fundSourceId/newCampaign'
    | '/admin/users/$subscriptionOrUserId/createNotification'
    | '/admin/users/$subscriptionOrUserId/issueBalance'
    | '/company/stores/$storeSlug/qrcode'
    | '/admin/companies/$companyId'
    | '/admin/companies/bulkCreateCompanies'
    | '/admin/companies/bulkCreateQrcodes'
    | '/admin/companies/bulkCreateStaffAccounts'
    | '/admin/companies/bulkCreateStoreAccounts'
    | '/admin/hokkaido/code-statuses'
    | '/admin/hokkaido/csvs'
    | '/admin/hokkaido/exports'
    | '/admin/hokkaido/myna-applications'
    | '/admin/hokkaido/paper-vouchers'
    | '/admin/hokkaido/postal-returns'
    | '/admin/points/$fundSourceId'
    | '/admin/points/bulkCreateStandaloneDistributionCodes'
    | '/admin/points/bulkGrantPoints'
    | '/admin/users/$subscriptionOrUserId'
    | '/company/stores/$storeSlug'
    | '/admin/companies/$companyId/$storeId/edit'
    | '/admin/users/$subscriptionOrUserId/notifications/$id'
    | '/admin/companies/$companyId/$storeId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/company'
    | '/store'
    | '/company/contact'
    | '/company/dashboard'
    | '/company/redemptions'
    | '/company/transactions'
    | '/login/admin'
    | '/login/company'
    | '/login/store'
    | '/store/dashboard'
    | '/store/qrcode'
    | '/store/transactions'
    | '/admin/'
    | '/store/'
    | '/admin/companies/newCompany'
    | '/admin/fundSources/newFundSource'
    | '/admin/notifications/$id'
    | '/admin/notifications/new'
    | '/admin/companies/'
    | '/admin/distribution-codes/'
    | '/admin/fundSources/'
    | '/admin/notifications/'
    | '/admin/points/'
    | '/admin/settlements/'
    | '/admin/stores/'
    | '/admin/users/'
    | '/company/stores/'
    | '/admin/companies/$companyId/newStores'
    | '/admin/fundSources/$fundSourceId/edit'
    | '/admin/points/$fundSourceId/newCampaign'
    | '/admin/users/$subscriptionOrUserId/createNotification'
    | '/admin/users/$subscriptionOrUserId/issueBalance'
    | '/company/stores/$storeSlug/qrcode'
    | '/admin/companies/$companyId/'
    | '/admin/companies/bulkCreateCompanies/'
    | '/admin/companies/bulkCreateQrcodes/'
    | '/admin/companies/bulkCreateStaffAccounts/'
    | '/admin/companies/bulkCreateStoreAccounts/'
    | '/admin/hokkaido/code-statuses/'
    | '/admin/hokkaido/csvs/'
    | '/admin/hokkaido/exports/'
    | '/admin/hokkaido/myna-applications/'
    | '/admin/hokkaido/paper-vouchers/'
    | '/admin/hokkaido/postal-returns/'
    | '/admin/points/$fundSourceId/'
    | '/admin/points/bulkCreateStandaloneDistributionCodes/'
    | '/admin/points/bulkGrantPoints/'
    | '/admin/users/$subscriptionOrUserId/'
    | '/company/stores/$storeSlug/'
    | '/admin/companies/$companyId/$storeId/edit'
    | '/admin/users/$subscriptionOrUserId/notifications/$id'
    | '/admin/companies/$companyId/$storeId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  CompanyRoute: typeof CompanyRouteWithChildren
  StoreRoute: typeof StoreRouteWithChildren
  LoginAdminRoute: typeof LoginAdminRoute
  LoginCompanyRoute: typeof LoginCompanyRoute
  LoginStoreRoute: typeof LoginStoreRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/store': {
      id: '/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof StoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company': {
      id: '/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof CompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/store/': {
      id: '/store/'
      path: '/'
      fullPath: '/store/'
      preLoaderRoute: typeof StoreIndexRouteImport
      parentRoute: typeof StoreRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/store/transactions': {
      id: '/store/transactions'
      path: '/transactions'
      fullPath: '/store/transactions'
      preLoaderRoute: typeof StoreTransactionsRouteImport
      parentRoute: typeof StoreRoute
    }
    '/store/qrcode': {
      id: '/store/qrcode'
      path: '/qrcode'
      fullPath: '/store/qrcode'
      preLoaderRoute: typeof StoreQrcodeRouteImport
      parentRoute: typeof StoreRoute
    }
    '/store/dashboard': {
      id: '/store/dashboard'
      path: '/dashboard'
      fullPath: '/store/dashboard'
      preLoaderRoute: typeof StoreDashboardRouteImport
      parentRoute: typeof StoreRoute
    }
    '/login/store': {
      id: '/login/store'
      path: '/login/store'
      fullPath: '/login/store'
      preLoaderRoute: typeof LoginStoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/company': {
      id: '/login/company'
      path: '/login/company'
      fullPath: '/login/company'
      preLoaderRoute: typeof LoginCompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/admin': {
      id: '/login/admin'
      path: '/login/admin'
      fullPath: '/login/admin'
      preLoaderRoute: typeof LoginAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company/transactions': {
      id: '/company/transactions'
      path: '/transactions'
      fullPath: '/company/transactions'
      preLoaderRoute: typeof CompanyTransactionsRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/redemptions': {
      id: '/company/redemptions'
      path: '/redemptions'
      fullPath: '/company/redemptions'
      preLoaderRoute: typeof CompanyRedemptionsRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/dashboard': {
      id: '/company/dashboard'
      path: '/dashboard'
      fullPath: '/company/dashboard'
      preLoaderRoute: typeof CompanyDashboardRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/contact': {
      id: '/company/contact'
      path: '/contact'
      fullPath: '/company/contact'
      preLoaderRoute: typeof CompanyContactRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/company/stores/': {
      id: '/company/stores/'
      path: '/stores'
      fullPath: '/company/stores'
      preLoaderRoute: typeof CompanyStoresIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/stores/': {
      id: '/admin/stores/'
      path: '/stores'
      fullPath: '/admin/stores'
      preLoaderRoute: typeof AdminStoresIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settlements/': {
      id: '/admin/settlements/'
      path: '/settlements'
      fullPath: '/admin/settlements'
      preLoaderRoute: typeof AdminSettlementsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/points/': {
      id: '/admin/points/'
      path: '/points'
      fullPath: '/admin/points'
      preLoaderRoute: typeof AdminPointsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/notifications/': {
      id: '/admin/notifications/'
      path: '/notifications'
      fullPath: '/admin/notifications'
      preLoaderRoute: typeof AdminNotificationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/fundSources/': {
      id: '/admin/fundSources/'
      path: '/fundSources'
      fullPath: '/admin/fundSources'
      preLoaderRoute: typeof AdminFundSourcesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/distribution-codes/': {
      id: '/admin/distribution-codes/'
      path: '/distribution-codes'
      fullPath: '/admin/distribution-codes'
      preLoaderRoute: typeof AdminDistributionCodesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/': {
      id: '/admin/companies/'
      path: '/companies'
      fullPath: '/admin/companies'
      preLoaderRoute: typeof AdminCompaniesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/notifications/new': {
      id: '/admin/notifications/new'
      path: '/notifications/new'
      fullPath: '/admin/notifications/new'
      preLoaderRoute: typeof AdminNotificationsNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/notifications/$id': {
      id: '/admin/notifications/$id'
      path: '/notifications/$id'
      fullPath: '/admin/notifications/$id'
      preLoaderRoute: typeof AdminNotificationsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/fundSources/newFundSource': {
      id: '/admin/fundSources/newFundSource'
      path: '/fundSources/newFundSource'
      fullPath: '/admin/fundSources/newFundSource'
      preLoaderRoute: typeof AdminFundSourcesNewFundSourceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/newCompany': {
      id: '/admin/companies/newCompany'
      path: '/companies/newCompany'
      fullPath: '/admin/companies/newCompany'
      preLoaderRoute: typeof AdminCompaniesNewCompanyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/company/stores/$storeSlug/': {
      id: '/company/stores/$storeSlug/'
      path: '/stores/$storeSlug'
      fullPath: '/company/stores/$storeSlug'
      preLoaderRoute: typeof CompanyStoresStoreSlugIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/admin/users/$subscriptionOrUserId/': {
      id: '/admin/users/$subscriptionOrUserId/'
      path: '/users/$subscriptionOrUserId'
      fullPath: '/admin/users/$subscriptionOrUserId'
      preLoaderRoute: typeof AdminUsersSubscriptionOrUserIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/points/bulkGrantPoints/': {
      id: '/admin/points/bulkGrantPoints/'
      path: '/points/bulkGrantPoints'
      fullPath: '/admin/points/bulkGrantPoints'
      preLoaderRoute: typeof AdminPointsBulkGrantPointsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/points/bulkCreateStandaloneDistributionCodes/': {
      id: '/admin/points/bulkCreateStandaloneDistributionCodes/'
      path: '/points/bulkCreateStandaloneDistributionCodes'
      fullPath: '/admin/points/bulkCreateStandaloneDistributionCodes'
      preLoaderRoute: typeof AdminPointsBulkCreateStandaloneDistributionCodesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/points/$fundSourceId/': {
      id: '/admin/points/$fundSourceId/'
      path: '/points/$fundSourceId'
      fullPath: '/admin/points/$fundSourceId'
      preLoaderRoute: typeof AdminPointsFundSourceIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/hokkaido/postal-returns/': {
      id: '/admin/hokkaido/postal-returns/'
      path: '/hokkaido/postal-returns'
      fullPath: '/admin/hokkaido/postal-returns'
      preLoaderRoute: typeof AdminHokkaidoPostalReturnsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/hokkaido/paper-vouchers/': {
      id: '/admin/hokkaido/paper-vouchers/'
      path: '/hokkaido/paper-vouchers'
      fullPath: '/admin/hokkaido/paper-vouchers'
      preLoaderRoute: typeof AdminHokkaidoPaperVouchersIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/hokkaido/myna-applications/': {
      id: '/admin/hokkaido/myna-applications/'
      path: '/hokkaido/myna-applications'
      fullPath: '/admin/hokkaido/myna-applications'
      preLoaderRoute: typeof AdminHokkaidoMynaApplicationsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/hokkaido/exports/': {
      id: '/admin/hokkaido/exports/'
      path: '/hokkaido/exports'
      fullPath: '/admin/hokkaido/exports'
      preLoaderRoute: typeof AdminHokkaidoExportsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/hokkaido/csvs/': {
      id: '/admin/hokkaido/csvs/'
      path: '/hokkaido/csvs'
      fullPath: '/admin/hokkaido/csvs'
      preLoaderRoute: typeof AdminHokkaidoCsvsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/hokkaido/code-statuses/': {
      id: '/admin/hokkaido/code-statuses/'
      path: '/hokkaido/code-statuses'
      fullPath: '/admin/hokkaido/code-statuses'
      preLoaderRoute: typeof AdminHokkaidoCodeStatusesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/bulkCreateStoreAccounts/': {
      id: '/admin/companies/bulkCreateStoreAccounts/'
      path: '/companies/bulkCreateStoreAccounts'
      fullPath: '/admin/companies/bulkCreateStoreAccounts'
      preLoaderRoute: typeof AdminCompaniesBulkCreateStoreAccountsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/bulkCreateStaffAccounts/': {
      id: '/admin/companies/bulkCreateStaffAccounts/'
      path: '/companies/bulkCreateStaffAccounts'
      fullPath: '/admin/companies/bulkCreateStaffAccounts'
      preLoaderRoute: typeof AdminCompaniesBulkCreateStaffAccountsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/bulkCreateQrcodes/': {
      id: '/admin/companies/bulkCreateQrcodes/'
      path: '/companies/bulkCreateQrcodes'
      fullPath: '/admin/companies/bulkCreateQrcodes'
      preLoaderRoute: typeof AdminCompaniesBulkCreateQrcodesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/bulkCreateCompanies/': {
      id: '/admin/companies/bulkCreateCompanies/'
      path: '/companies/bulkCreateCompanies'
      fullPath: '/admin/companies/bulkCreateCompanies'
      preLoaderRoute: typeof AdminCompaniesBulkCreateCompaniesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/$companyId/': {
      id: '/admin/companies/$companyId/'
      path: '/companies/$companyId'
      fullPath: '/admin/companies/$companyId'
      preLoaderRoute: typeof AdminCompaniesCompanyIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/company/stores/$storeSlug/qrcode': {
      id: '/company/stores/$storeSlug/qrcode'
      path: '/stores/$storeSlug/qrcode'
      fullPath: '/company/stores/$storeSlug/qrcode'
      preLoaderRoute: typeof CompanyStoresStoreSlugQrcodeRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/admin/users/$subscriptionOrUserId/issueBalance': {
      id: '/admin/users/$subscriptionOrUserId/issueBalance'
      path: '/users/$subscriptionOrUserId/issueBalance'
      fullPath: '/admin/users/$subscriptionOrUserId/issueBalance'
      preLoaderRoute: typeof AdminUsersSubscriptionOrUserIdIssueBalanceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/$subscriptionOrUserId/createNotification': {
      id: '/admin/users/$subscriptionOrUserId/createNotification'
      path: '/users/$subscriptionOrUserId/createNotification'
      fullPath: '/admin/users/$subscriptionOrUserId/createNotification'
      preLoaderRoute: typeof AdminUsersSubscriptionOrUserIdCreateNotificationRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/points/$fundSourceId/newCampaign': {
      id: '/admin/points/$fundSourceId/newCampaign'
      path: '/points/$fundSourceId/newCampaign'
      fullPath: '/admin/points/$fundSourceId/newCampaign'
      preLoaderRoute: typeof AdminPointsFundSourceIdNewCampaignRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/fundSources/$fundSourceId/edit': {
      id: '/admin/fundSources/$fundSourceId/edit'
      path: '/fundSources/$fundSourceId/edit'
      fullPath: '/admin/fundSources/$fundSourceId/edit'
      preLoaderRoute: typeof AdminFundSourcesFundSourceIdEditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/$companyId/newStores': {
      id: '/admin/companies/$companyId/newStores'
      path: '/companies/$companyId/newStores'
      fullPath: '/admin/companies/$companyId/newStores'
      preLoaderRoute: typeof AdminCompaniesCompanyIdNewStoresRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/$companyId/$storeId/': {
      id: '/admin/companies/$companyId/$storeId/'
      path: '/companies/$companyId/$storeId'
      fullPath: '/admin/companies/$companyId/$storeId'
      preLoaderRoute: typeof AdminCompaniesCompanyIdStoreIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users/$subscriptionOrUserId/notifications/$id': {
      id: '/admin/users/$subscriptionOrUserId/notifications/$id'
      path: '/users/$subscriptionOrUserId/notifications/$id'
      fullPath: '/admin/users/$subscriptionOrUserId/notifications/$id'
      preLoaderRoute: typeof AdminUsersSubscriptionOrUserIdNotificationsIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/companies/$companyId/$storeId/edit': {
      id: '/admin/companies/$companyId/$storeId/edit'
      path: '/companies/$companyId/$storeId/edit'
      fullPath: '/admin/companies/$companyId/$storeId/edit'
      preLoaderRoute: typeof AdminCompaniesCompanyIdStoreIdEditRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCompaniesNewCompanyRoute: typeof AdminCompaniesNewCompanyRoute
  AdminFundSourcesNewFundSourceRoute: typeof AdminFundSourcesNewFundSourceRoute
  AdminNotificationsIdRoute: typeof AdminNotificationsIdRoute
  AdminNotificationsNewRoute: typeof AdminNotificationsNewRoute
  AdminCompaniesIndexRoute: typeof AdminCompaniesIndexRoute
  AdminDistributionCodesIndexRoute: typeof AdminDistributionCodesIndexRoute
  AdminFundSourcesIndexRoute: typeof AdminFundSourcesIndexRoute
  AdminNotificationsIndexRoute: typeof AdminNotificationsIndexRoute
  AdminPointsIndexRoute: typeof AdminPointsIndexRoute
  AdminSettlementsIndexRoute: typeof AdminSettlementsIndexRoute
  AdminStoresIndexRoute: typeof AdminStoresIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminCompaniesCompanyIdNewStoresRoute: typeof AdminCompaniesCompanyIdNewStoresRoute
  AdminFundSourcesFundSourceIdEditRoute: typeof AdminFundSourcesFundSourceIdEditRoute
  AdminPointsFundSourceIdNewCampaignRoute: typeof AdminPointsFundSourceIdNewCampaignRoute
  AdminUsersSubscriptionOrUserIdCreateNotificationRoute: typeof AdminUsersSubscriptionOrUserIdCreateNotificationRoute
  AdminUsersSubscriptionOrUserIdIssueBalanceRoute: typeof AdminUsersSubscriptionOrUserIdIssueBalanceRoute
  AdminCompaniesCompanyIdIndexRoute: typeof AdminCompaniesCompanyIdIndexRoute
  AdminCompaniesBulkCreateCompaniesIndexRoute: typeof AdminCompaniesBulkCreateCompaniesIndexRoute
  AdminCompaniesBulkCreateQrcodesIndexRoute: typeof AdminCompaniesBulkCreateQrcodesIndexRoute
  AdminCompaniesBulkCreateStaffAccountsIndexRoute: typeof AdminCompaniesBulkCreateStaffAccountsIndexRoute
  AdminCompaniesBulkCreateStoreAccountsIndexRoute: typeof AdminCompaniesBulkCreateStoreAccountsIndexRoute
  AdminHokkaidoCodeStatusesIndexRoute: typeof AdminHokkaidoCodeStatusesIndexRoute
  AdminHokkaidoCsvsIndexRoute: typeof AdminHokkaidoCsvsIndexRoute
  AdminHokkaidoExportsIndexRoute: typeof AdminHokkaidoExportsIndexRoute
  AdminHokkaidoMynaApplicationsIndexRoute: typeof AdminHokkaidoMynaApplicationsIndexRoute
  AdminHokkaidoPaperVouchersIndexRoute: typeof AdminHokkaidoPaperVouchersIndexRoute
  AdminHokkaidoPostalReturnsIndexRoute: typeof AdminHokkaidoPostalReturnsIndexRoute
  AdminPointsFundSourceIdIndexRoute: typeof AdminPointsFundSourceIdIndexRoute
  AdminPointsBulkCreateStandaloneDistributionCodesIndexRoute: typeof AdminPointsBulkCreateStandaloneDistributionCodesIndexRoute
  AdminPointsBulkGrantPointsIndexRoute: typeof AdminPointsBulkGrantPointsIndexRoute
  AdminUsersSubscriptionOrUserIdIndexRoute: typeof AdminUsersSubscriptionOrUserIdIndexRoute
  AdminCompaniesCompanyIdStoreIdEditRoute: typeof AdminCompaniesCompanyIdStoreIdEditRoute
  AdminUsersSubscriptionOrUserIdNotificationsIdRoute: typeof AdminUsersSubscriptionOrUserIdNotificationsIdRoute
  AdminCompaniesCompanyIdStoreIdIndexRoute: typeof AdminCompaniesCompanyIdStoreIdIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminCompaniesNewCompanyRoute: AdminCompaniesNewCompanyRoute,
  AdminFundSourcesNewFundSourceRoute: AdminFundSourcesNewFundSourceRoute,
  AdminNotificationsIdRoute: AdminNotificationsIdRoute,
  AdminNotificationsNewRoute: AdminNotificationsNewRoute,
  AdminCompaniesIndexRoute: AdminCompaniesIndexRoute,
  AdminDistributionCodesIndexRoute: AdminDistributionCodesIndexRoute,
  AdminFundSourcesIndexRoute: AdminFundSourcesIndexRoute,
  AdminNotificationsIndexRoute: AdminNotificationsIndexRoute,
  AdminPointsIndexRoute: AdminPointsIndexRoute,
  AdminSettlementsIndexRoute: AdminSettlementsIndexRoute,
  AdminStoresIndexRoute: AdminStoresIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminCompaniesCompanyIdNewStoresRoute: AdminCompaniesCompanyIdNewStoresRoute,
  AdminFundSourcesFundSourceIdEditRoute: AdminFundSourcesFundSourceIdEditRoute,
  AdminPointsFundSourceIdNewCampaignRoute:
    AdminPointsFundSourceIdNewCampaignRoute,
  AdminUsersSubscriptionOrUserIdCreateNotificationRoute:
    AdminUsersSubscriptionOrUserIdCreateNotificationRoute,
  AdminUsersSubscriptionOrUserIdIssueBalanceRoute:
    AdminUsersSubscriptionOrUserIdIssueBalanceRoute,
  AdminCompaniesCompanyIdIndexRoute: AdminCompaniesCompanyIdIndexRoute,
  AdminCompaniesBulkCreateCompaniesIndexRoute:
    AdminCompaniesBulkCreateCompaniesIndexRoute,
  AdminCompaniesBulkCreateQrcodesIndexRoute:
    AdminCompaniesBulkCreateQrcodesIndexRoute,
  AdminCompaniesBulkCreateStaffAccountsIndexRoute:
    AdminCompaniesBulkCreateStaffAccountsIndexRoute,
  AdminCompaniesBulkCreateStoreAccountsIndexRoute:
    AdminCompaniesBulkCreateStoreAccountsIndexRoute,
  AdminHokkaidoCodeStatusesIndexRoute: AdminHokkaidoCodeStatusesIndexRoute,
  AdminHokkaidoCsvsIndexRoute: AdminHokkaidoCsvsIndexRoute,
  AdminHokkaidoExportsIndexRoute: AdminHokkaidoExportsIndexRoute,
  AdminHokkaidoMynaApplicationsIndexRoute:
    AdminHokkaidoMynaApplicationsIndexRoute,
  AdminHokkaidoPaperVouchersIndexRoute: AdminHokkaidoPaperVouchersIndexRoute,
  AdminHokkaidoPostalReturnsIndexRoute: AdminHokkaidoPostalReturnsIndexRoute,
  AdminPointsFundSourceIdIndexRoute: AdminPointsFundSourceIdIndexRoute,
  AdminPointsBulkCreateStandaloneDistributionCodesIndexRoute:
    AdminPointsBulkCreateStandaloneDistributionCodesIndexRoute,
  AdminPointsBulkGrantPointsIndexRoute: AdminPointsBulkGrantPointsIndexRoute,
  AdminUsersSubscriptionOrUserIdIndexRoute:
    AdminUsersSubscriptionOrUserIdIndexRoute,
  AdminCompaniesCompanyIdStoreIdEditRoute:
    AdminCompaniesCompanyIdStoreIdEditRoute,
  AdminUsersSubscriptionOrUserIdNotificationsIdRoute:
    AdminUsersSubscriptionOrUserIdNotificationsIdRoute,
  AdminCompaniesCompanyIdStoreIdIndexRoute:
    AdminCompaniesCompanyIdStoreIdIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface CompanyRouteChildren {
  CompanyContactRoute: typeof CompanyContactRoute
  CompanyDashboardRoute: typeof CompanyDashboardRoute
  CompanyRedemptionsRoute: typeof CompanyRedemptionsRoute
  CompanyTransactionsRoute: typeof CompanyTransactionsRoute
  CompanyStoresIndexRoute: typeof CompanyStoresIndexRoute
  CompanyStoresStoreSlugQrcodeRoute: typeof CompanyStoresStoreSlugQrcodeRoute
  CompanyStoresStoreSlugIndexRoute: typeof CompanyStoresStoreSlugIndexRoute
}

const CompanyRouteChildren: CompanyRouteChildren = {
  CompanyContactRoute: CompanyContactRoute,
  CompanyDashboardRoute: CompanyDashboardRoute,
  CompanyRedemptionsRoute: CompanyRedemptionsRoute,
  CompanyTransactionsRoute: CompanyTransactionsRoute,
  CompanyStoresIndexRoute: CompanyStoresIndexRoute,
  CompanyStoresStoreSlugQrcodeRoute: CompanyStoresStoreSlugQrcodeRoute,
  CompanyStoresStoreSlugIndexRoute: CompanyStoresStoreSlugIndexRoute,
}

const CompanyRouteWithChildren =
  CompanyRoute._addFileChildren(CompanyRouteChildren)

interface StoreRouteChildren {
  StoreDashboardRoute: typeof StoreDashboardRoute
  StoreQrcodeRoute: typeof StoreQrcodeRoute
  StoreTransactionsRoute: typeof StoreTransactionsRoute
  StoreIndexRoute: typeof StoreIndexRoute
}

const StoreRouteChildren: StoreRouteChildren = {
  StoreDashboardRoute: StoreDashboardRoute,
  StoreQrcodeRoute: StoreQrcodeRoute,
  StoreTransactionsRoute: StoreTransactionsRoute,
  StoreIndexRoute: StoreIndexRoute,
}

const StoreRouteWithChildren = StoreRoute._addFileChildren(StoreRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  CompanyRoute: CompanyRouteWithChildren,
  StoreRoute: StoreRouteWithChildren,
  LoginAdminRoute: LoginAdminRoute,
  LoginCompanyRoute: LoginCompanyRoute,
  LoginStoreRoute: LoginStoreRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
